import { type RoomDMaxInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { useNewNavigate, usePensionNameValue } from "@shared/client";
import { useRef, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { CustomButton, CustomCenter } from "./roomPreview.style";

export const RoomPreview = ({ room }: { room: RoomDMaxInfoResponse }) => {
    const { onNavigate } = useNewNavigate();
    const pensionName = usePensionNameValue();
    const [currentSlide, setCurrentSlide] = useState(0);
    const carouselRef = useRef<Carousel>(null);
    const { isLaptop, isMobile } = MEDIA();

    const { rooms } = { ...room };

    const handlePrev = () => {
        carouselRef.current?.moveTo(carouselRef.current.state.selectedItem - 1);
    };
    const handleNext = () => {
        carouselRef.current?.moveTo(carouselRef.current.state.selectedItem + 1);
    };
    return (
        <Center as="section" w="100%" background="#f8f8f8" maxW="none !important">
            <CustomCenter
                display="flex"
                flexDir="column"
                boxSizing="border-box"
                overflow="hidden"
                maxW="1920px"
                rowGap={isMobile ? "24px" : "48px"}
                w="100%"
            >
                <Flex
                    maxW="1620px"
                    w="100%"
                    flexDir="column"
                    p={isMobile ? "0 16px" : "0 48px"}
                    sx={{
                        "& p": {
                            fontFamily: "Noto Serif KR",
                        },
                    }}
                >
                    <Text fontWeight="400" lineHeight="140%" fontSize={isMobile ? "16px" : "24px"}>
                        {pensionName.kor}의 객실
                    </Text>
                    <Text fontWeight="600" lineHeight="140%" fontSize={isMobile ? "20px" : "40px"}>
                        {pensionName.eng} ROOMS
                    </Text>
                </Flex>
                <Box position="relative" w="inherit">
                    <Carousel
                        ref={carouselRef}
                        showIndicators={false}
                        showStatus={false}
                        showArrows={false}
                        infiniteLoop
                        emulateTouch
                        preventMovementUntilSwipeScrollTolerance
                        swipeScrollTolerance={100}
                        selectedItem={currentSlide}
                        onChange={(index) => setCurrentSlide(index)}
                    >
                        {rooms.map((t) => {
                            return (
                                <Flex
                                    key={t.room_idx}
                                    w="100%"
                                    columnGap="48px"
                                    rowGap="24px"
                                    flexDir={isMobile ? "column" : "row"}
                                >
                                    <Center
                                        maxW="936px"
                                        w="100%"
                                        h={isMobile ? "328px" : "708px"}
                                        boxSizing="border-box"
                                        key={t.room_idx}
                                        background={
                                            t.imgList[0]
                                                ? `url(${t.imgList[0].img_URL}) no-repeat center/cover`
                                                : "gray.100"
                                        }
                                    />
                                    <Center maxW="936px" w="100%">
                                        <Flex w="100%" columnGap="24px">
                                            <Flex
                                                w="100%"
                                                h={isMobile ? "216px" : "320px"}
                                                flexDir="column"
                                                alignItems="flex-start"
                                                justifyContent="space-between"
                                                p={isMobile ? "0 16px" : "0"}
                                            >
                                                <Box textAlign="left">
                                                    <Text
                                                        mb="16px"
                                                        fontFamily="Noto Serif KR"
                                                        fontSize={isMobile ? "20px" : "32px"}
                                                        fontWeight="400"
                                                        lineHeight="140%"
                                                    >
                                                        {t.room_name}
                                                    </Text>
                                                    <Box
                                                        sx={{
                                                            "& p": {
                                                                fontFamily: "Pretendard",
                                                                fontSize: isMobile ? "14px" : "16px",
                                                                lineHeight: "140%",
                                                                fontWeight: "300",
                                                                color: "#6b6b6b",
                                                            },
                                                        }}
                                                    >
                                                        <Text>{t.room_intro}</Text>
                                                        <Text>{t.room_type}</Text>
                                                    </Box>
                                                </Box>
                                                <CustomButton
                                                    size="medium"
                                                    onClick={() => onNavigate({ path: `/rooms/${t.room_idx}` })}
                                                >
                                                    자세히보기
                                                </CustomButton>
                                            </Flex>
                                            {!isLaptop && (
                                                <Box
                                                    maxW="408px"
                                                    w="100%"
                                                    h="480px"
                                                    background={
                                                        t.imgList[1]
                                                            ? `url(${t.imgList[1].img_URL})no-repeat center/cover`
                                                            : "gray.100"
                                                    }
                                                />
                                            )}
                                        </Flex>
                                    </Center>
                                </Flex>
                            );
                        })}
                    </Carousel>
                    <Flex
                        position="absolute"
                        bottom={isMobile ? "0" : "40px"}
                        right="10%"
                        sx={{
                            "& .arrow_prev,.arrow_next": {
                                w: isMobile ? "8px" : "12px",
                                h: isMobile ? "16px" : "24px",
                            },
                        }}
                    >
                        <Center w={isMobile ? "32PX" : "48PX"} h={isMobile ? "32PX" : "48PX"} cursor="pointer">
                            <Box
                                className="arrow_prev"
                                w="24px"
                                h="12px"
                                onClick={handlePrev}
                                background={`url(${process.env.PUBLIC_URL}/assets/left_arrow.png) no-repeat center/cover`}
                            />
                        </Center>
                        <Center
                            w="88px"
                            sx={{
                                "& p": {
                                    fontFamily: "Pretendard",
                                    lineHeight: "140%",
                                },
                            }}
                        >
                            <Center w="48px">
                                <Text fontWeight="600" fontSize={isMobile ? "24px" : "36px"}>
                                    {currentSlide + 1}
                                </Text>
                            </Center>{" "}
                            <Text fontWeight="400" fontSize={isMobile ? "14px" : "16px"}>
                                / {rooms.length}
                            </Text>
                        </Center>
                        <Center w={isMobile ? "32PX" : "48PX"} h={isMobile ? "32PX" : "48PX"} cursor="pointer">
                            <Box
                                w="24px"
                                h="12px"
                                className="arrow_next"
                                onClick={handleNext}
                                background={`url(${process.env.PUBLIC_URL}/assets/right_arrow.png) no-repeat center/cover`}
                            />
                        </Center>
                    </Flex>
                </Box>
            </CustomCenter>
        </Center>
    );
};
